import { ChatMessage } from "@reporting/rp-types/ai";
import { ContextData } from "@reporting/rp-types/analytics";

export function extractContextDataFromChatMessage(message: ChatMessage): {from: number,to: number, data: ContextData}[] {
	// context data are in message.content property and are enclosed in "```view" and "```"
	const regex = /```view\s*([\s\S]*?)```/g;
	const matches = Array.from(message.content.matchAll(regex));
	const results: {from: number, to: number, data: ContextData}[] = [];

	for (const match of matches) {
		if (match[1] && match.index !== undefined) {
			// Track the position of this specific ``` block
			const from = match.index;
			const to = match.index + match[0].length;

			try {
				const parsed = JSON.parse(match[1]);
				parsed.version = '2'; // Ensure version is set to 2 for compatibility
				// Parsed data is always a single ContextData object
				results.push({
					from: from,
					to: to,
					data: parsed
				});
			} catch (e) {
				console.error("Failed to parse context data from chat message:", e);
			}
		}
	}

	return results;
}
